import React from 'react';
import PropTypes from 'prop-types';
import './TurnBackDevice.css';


export const TurnBackDevice = (props) => {
    const {
      lang,
    } = props;
  
    return (
      <div className="turnBackDevice">
        <div className="turnBackDeviceContainer">
            <div className="textContainer">
                <h2>{lang.title_notice}</h2>
                <p>{lang.turn_back_device}</p>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.692 22.169">
                  <g id="rotate_B" transform="translate(-1017.334 -209.962)">
                    <path id="Path_78" data-name="Path 78" d="M1061.154,236.887c0-.014,0-.028,0-.042s0-.006,0-.009a1.335,1.335,0,0,0-.018-.147v-.006c0-.015-.006-.031-.009-.046l0-.01c0-.015-.007-.03-.011-.046l0-.006a1.363,1.363,0,0,0-.069-.2l0,0-.021-.045,0-.006-.023-.045h0a1.355,1.355,0,0,0-.233-.312l-6.32-6.32-.686-.686-5-5a1.355,1.355,0,0,0-1.916,0l-6.048,6.048a1.355,1.355,0,0,0,0,1.916l12.006,12.006a1.355,1.355,0,0,0,1.916,0l5.31-5.31.738-.738.044-.047.014-.015.028-.033.015-.018.025-.033.014-.018.026-.037.01-.015.032-.052.008-.014.022-.039.011-.021.016-.033.011-.023.014-.033.01-.023.014-.038.009-.026c.005-.016.01-.031.015-.047l.008-.027.008-.03.007-.03.006-.028c0-.01,0-.021.006-.032l0-.026c0-.011,0-.022.005-.033s0-.01,0-.016c0-.026.006-.052.008-.078,0-.006,0-.011,0-.017s0-.026,0-.039,0-.013,0-.019,0-.026,0-.039Zm-17.741-8.123,2.179-2.179a.08.08,0,1,1,.113.113l-2.179,2.179a.08.08,0,0,1-.113-.113Zm13.88,11.7a.792.792,0,1,1,0-1.121A.792.792,0,0,1,1057.293,240.466Zm-4.822,1.77-10.546-10.546,6.592-6.592,4.549,4.549.686.686,5.311,5.311Z" transform="translate(-21.713 -12.809)"/>
                    <path id="Path_79" data-name="Path 79" d="M1019.028,412.632l.731-.047-1.342-1.953-1.082,2.108.8-.051a9.514,9.514,0,0,0,9.438,8.408v-.9A8.618,8.618,0,0,1,1019.028,412.632Z" transform="translate(0 -188.965)"/>
                    <path id="Path_80" data-name="Path 80" d="M1256.632,219.153a9.512,9.512,0,0,0-9.5-9.191v.9a8.615,8.615,0,0,1,8.6,8.352l-.739.047,1.342,1.953,1.083-2.108Z" transform="translate(-216.398)"/>
                  </g>
                </svg>
            </div>
        </div>
      </div>
    );
};

TurnBackDevice.defaultProps = {
    lang: {},
};
  
TurnBackDevice.propTypes = {
    lang: PropTypes.object,
};

export default TurnBackDevice;


// WEBPACK FOOTER //
// ./src/components/turn-back-device/TurnBackDevice.jsx